import { createFileRoute } from '@tanstack/react-router'
import { ChangelogEntryPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/it/changelog/$entrySlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'changelogEntry', locale: 'it', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { entrySlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ChangelogEntryPage entrySlug={entrySlug} />
    </CatalogProvider>
  )
}
